function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEnergiot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1286.61 497.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0000",
      strokeWidth: 0
    },
    d: "M.5.5h1285.61v496.65H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.05 201.51h-94.33l15.51-27.96h94.39l-15.58 27.96Zm-70.74-41.66 161.76.38 22.71-39.41H200.64zm-54.95 94.69 94.56.45-18.64 31.89-60.27 101.74 216.56-173.81-209.93.02z",
    style: {
      strokeWidth: 0,
      fill: "#00e771"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.66 107.17h19.29v21.4h-19.29zm-24.48 66.49h.01v47.57c0 26.48-21.54 48.02-48.02 48.02H808.5v-18.73h36.67c16.15 0 29.29-13.14 29.29-29.29v-6.7c-9.24 7.85-21.19 12.6-34.24 12.6-29.21 0-52.97-23.76-52.97-52.97s23.76-52.97 52.97-52.97 52.69 23.5 52.96 52.48Zm-18.72.49c0-18.88-15.36-34.24-34.24-34.24s-34.24 15.36-34.24 34.24 15.36 34.24 34.24 34.24 34.24-15.36 34.24-34.24m192.79 0c0 29.21-23.76 52.97-52.97 52.97s-52.97-23.76-52.97-52.97 23.76-52.97 52.97-52.97 52.97 23.76 52.97 52.97m-18.73 0c0-18.88-15.36-34.24-34.24-34.24s-34.24 15.36-34.24 34.24 15.36 34.24 34.24 34.24 34.24-15.36 34.24-34.24m-496.47-49.5c-26.48 0-48.02 21.54-48.02 48.02v55.02h18.73v-55.02c0-16.15 13.14-29.29 29.29-29.29s29.29 13.14 29.29 29.29v55.02h18.73v-55.02c0-26.48-21.54-48.02-48.02-48.02m177.39 48.02v55.02h18.73v-55.02c0-16.15 13.14-29.29 29.29-29.29v-18.73c-26.48 0-48.02 21.54-48.02 48.02m-289-51.49c-29.21 0-52.97 23.76-52.97 52.97s23.52 52.67 52.42 52.97h.08l30.1-.23-.14-18.73-29.92.23c-18.65-.24-33.8-15.58-33.8-34.24s15.36-34.24 34.24-34.24c15.63 0 28.85 10.53 32.94 24.87h-53.26v18.73h73.29v-9.37c0-29.21-23.76-52.97-52.97-52.97Zm224.05 0c-29.21 0-52.97 23.76-52.97 52.97s23.52 52.67 52.42 52.97h.08l30.1-.23-.14-18.73-29.92.23c-18.65-.24-33.8-15.58-33.8-34.24s15.36-34.24 34.24-34.24c15.63 0 28.85 10.53 32.94 24.87h-53.26v18.73h73.29v-9.37c0-29.21-23.76-52.97-52.97-52.97Zm253.17 107.43h19.29v-95.22h-19.29zm218.59-75.28v-19.29h-29.67v-26.91h-18.73v26.91h-9.88v19.29h9.88v19.16c0 32.43 21.54 53.97 48.02 53.97v-18.73c-16.15 0-29.29-13.14-29.29-35.24v-19.16z",
    style: {
      strokeWidth: 0,
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEnergiot);
export default __webpack_public_path__ + "static/media/logo_energiot.18afac45007fcb651ea4bbc452812c46.svg";
export { ForwardRef as ReactComponent };